import config from "../../app.json";
import axios from "axios";

import "./newchat.scss";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import FieldText from "../Fields/FieldText";
import FieldSelect from "../Fields/FieldSelect";
import ModalComponent from "../ModalComponent";
import AlertComponent from "../AlertComponent";

import PlusIcon from "../../Assets/Images/plus.svg";

function NewChat(props) {
  const [chatName, setChatName] = useState(null);
  const [chatListId, setChatListId] = useState(0);
  const [chatListIdOption, setChatListIdOption] = useState(null);

  if (props.chatListId && props.chatListId !== chatListId) {
    setChatListId(props.chatListId);
  }
  useEffect(() => {
    if (chatListIdOption) {
      setChatListId(chatListIdOption.value);
    }
  }, [chatListIdOption]);

  const submit = async () => {
    if (chatName && chatListId) {
      const payload = {
        name: chatName,
        listId: chatListId,
      };
      await axios
        .post(config.API_HM + "/chats", payload)
        .then((a) => {
          setChatName(null);
          setChatListId(null);
          props.setShowCreateChat(false);
          if (props.afterCreateChat) {
            props.afterCreateChat(payload);
          }
        })
        .catch(function (error) {
          return AlertComponent("Error", error?.response?.data?.message || error?.message, { icon: `error` });
        });
    }
  };

  const hasChatListId = !props.mustSelectChatList;
  const sizeChatName = hasChatListId ? 12 : 12;

  const chatListOptions = hasChatListId ? null : (
    <Col md={sizeChatName}>
      <FieldSelect
        label={`Select Chatlist`}
        options={props.options}
        id={`chatListId`}
        name={`chatListId`}
        onChange={setChatListIdOption}
        value={chatListIdOption}
        placeholder={`Choose an option`}
      />
    </Col>
  );

  const content = (
    <Container className="newchat-container">
      <Row className="newchat-content">
        <h4 className="text-center">Create new chat</h4>
        <Col md={sizeChatName}>
          <FieldText
            label="Chat Name"
            type="text"
            onChange={(x) => setChatName(x.target.value)}
            placeholder="Chat Name"
            value={chatName}
            required={true}
            inputClassName={`inputOption`}
          />
        </Col>
        {chatListOptions}
        <Col md={12}>
          <div className="text-center d-flex justify-content-end ">
            <Button className="dark-btn new-chat-button" onClick={submit}>
              Create
            </Button>
          </div>
        </Col>
      </Row>
    </Container>
  );
  return <ModalComponent className="modal-container" data={content} modalIsOpen={props.showCreateChat} setModalIsOpen={props.setShowCreateChat} showCloseText={false} />;
}

export default NewChat;
